import { render } from "./Network.vue?vue&type=template&id=2bfd463f"
import script from "./Network.vue?vue&type=script&lang=js"
export * from "./Network.vue?vue&type=script&lang=js"
script.render = render

export default script